import { render, staticRenderFns } from "./DialogNote.vue?vue&type=template&id=53c5c686"
import script from "./DialogNote.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogNote.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports